// Default i18n messages for gatsby-theme-domosoft
// Sites can override/extend these via theme options

const defaultMessages = {
    en: {
        "postsPage.recentPosts": "Recent Posts",
        "postsPage.availableInOtherLanguages": "Available in Other Languages",
        "postPage.RelatedPosts": "Related Posts",
        "collection.author.publishedBy": "{name}",
        "collection.author.socialMedia": "Social Media",
        "postPage.tableOfContents": "Table of Contents",
        "postPage.share": "Share"
    },
    de: {
        "postsPage.recentPosts": "Neueste Beiträge",
        "postsPage.availableInOtherLanguages": "In anderen Sprachen verfügbar",
        "postPage.RelatedPosts": "Ähnliche Beiträge",
        "collection.author.publishedBy": "{name}",
        "collection.author.socialMedia": "Soziale Netzwerke",
        "postPage.tableOfContents": "Inhaltsverzeichnis",
        "postPage.share": "Teilen"
    },
    fr: {
        "postsPage.recentPosts": "Publications récentes",
        "postsPage.availableInOtherLanguages": "Disponible dans d'autres langues",
        "postPage.RelatedPosts": "Articles similaires",
        "collection.author.publishedBy": "{name}",
        "collection.author.socialMedia": "Réseaux sociaux",
        "postPage.tableOfContents": "Table des matières",
        "postPage.share": "Partager"
    },
}

module.exports = defaultMessages